import React from "react";

import { Markdown } from "@containers/Markdown";

import { useTranslate } from "@hooks/useTranslate";

import { Group } from "../Group";

import * as Styled from "./OfficesList.styled";

export const OfficesList: React.FC = () => {
  const translate = useTranslate("batmaid_pwa_footer");

  return (
    <Group title={translate("offices_header")}>
      <Markdown
        components={{
          ul: props => <Styled.OfficesList {...props} />,
          li: props => <Styled.Office {...props} />,
          strong: props => <Styled.OfficeHeader {...props} />,
        }}
      >
        {translate("offices")}
      </Markdown>
    </Group>
  );
};
